import { render } from "./EmailChange.vue?vue&type=template&id=29cda943"
import script from "./EmailChange.vue?vue&type=script&lang=js"
export * from "./EmailChange.vue?vue&type=script&lang=js"

import "./EmailChange.vue?vue&type=style&index=0&id=29cda943&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__